import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';

interface PublicRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

/**
 * Composant pour les routes publiques (login, register)
 * Redirige automatiquement les utilisateurs connectés
 */
const PublicRoute: React.FC<PublicRouteProps> = ({ children, redirectTo = '/' }) => {
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useAuth();

  useEffect(() => {
    // Attendre que le contexte auth soit chargé
    if (loading) return;

    // Si l'utilisateur est connecté, rediriger
    if (isAuthenticated) {
      navigate(redirectTo, { replace: true });
    }
  }, [loading, isAuthenticated, navigate, redirectTo]);

  // Afficher un écran de chargement pendant la vérification
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Vérification...</p>
        </div>
      </div>
    );
  }

  // Si l'utilisateur est connecté, ne rien afficher (redirection en cours)
  if (isAuthenticated) {
    return null;
  }

  // Sinon, afficher le contenu (page login/register)
  return <>{children}</>;
};

export default PublicRoute;
